"use client";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { recoverFromChunkError } from "@/lib/chunk-error";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Errores de carga de chunk (deploy/rollout): recargar una vez en lugar de
    // mostrar la pantalla de error crítico.
    recoverFromChunkError(error);
  }, [error]);

  return (
    <html>
      <Toaster richColors={true} />
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
          <div className="flex max-w-md flex-col items-center space-y-8 text-center">
            <div className="flex flex-col items-center space-y-4">
              <Image
                src="/logo-full.svg"
                alt="RAJO TRANSPORTES"
                width={200}
                height={200}
                priority
                className="mb-6"
              />
              <h1 className="text-4xl font-bold text-destructive">
                Error crítico
              </h1>
              <h2 className="text-2xl font-semibold text-foreground">
                La aplicación no está disponible
              </h2>
            </div>
            <p className="text-muted-foreground">
              Ha ocurrido un error crítico. Por favor, reinicia la aplicación o
              contacta al soporte.
            </p>
            <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
              <Button
                variant="default"
                size="lg"
                className="w-full sm:w-auto"
                onClick={() => location.reload()}
              >
                Reiniciar aplicación
              </Button>
            </div>
            {error.digest && (
              <p className="text-xs text-muted-foreground">
                Código de error: {error.digest}
              </p>
            )}
          </div>
        </div>
      </body>
    </html>
  );
}
